import { useStoreState } from '@src/store/store';

export function useVisibleSidebar() {
  const isVisibleSidebar = useStoreState((state) => state.sidebars.isOpened);

  return isVisibleSidebar;
}
